import React, { useState, useRef } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { motion } from "framer-motion";

import TabItem from "./TabItem";
import Slide from "./Slide";

//style rules
import { Sizes, Colors } from "../../styles";

const App = ({ tabsJson }) => {
	const [slides] = useState(JSON.parse(tabsJson));
	const [selectedSlide, setSelectedSlide] = useState(slides[0].title);

	// used for animating the slides on toggle
	const ref = useRef(0);

	const toggleSlide = (slide) => {
		ref.current++; // used for triggering animation
		return setSelectedSlide(slide.title);
	};

	const renderSlideToggles = () => {
		if (!slides || slides.length == 0) return;

		return (
			<ToggleSection>
				{slides.map((slide, i) => (
					<TabItem
						key={i}
						filter={slide}
						isActive={slide.title === selectedSlide}
						handleFilterSelect={toggleSlide}
					/>
				))}
			</ToggleSection>
		);
	};

	const renderSlides = () => {
		if (!slides || slides.length == 0) return;

		let sideToDisplay = slides.find((slide) => slide.title === selectedSlide);
		return <Slide slide={sideToDisplay} />;
	};

	return (
		<>
			{renderSlideToggles()}
			<SlidesContainer
				animate={ref.current === 0 ? {} : { opacity: [0, 1] }}
				transition={{
					duration: 0.7,
				}}
				key={ref.current}
			>
				{renderSlides()}
			</SlidesContainer>
		</>
	);
};

App.propTypes = {
	tabsJson: PropTypes.string,
};

export default App;

const SlidesContainer = styled(motion.div)`
	display: flex;
	flex-direction: column;
	gap: 7rem;
	border-radius: 4rem;
	background-color: ${Colors.fp.lightBlue};
	position: relative;
	width: 100vw;
	left: 50%;
	right: 50%;
	margin-left: -50vw;
	margin-right: -50vw;
	text-align: center;
	max-width: unset;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		position: unset;
		width: unset;
		left: unset;
		right: unset;
		margin-left: unset;
		margin-right: unset;
		text-align: unset;
		gap: unset;
		margin-top: 5rem;
		border-radius: 6rem;
	}
`;

const ToggleSection = styled.ul`
	margin: 0;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: 1rem;
	padding-left: 0;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		display: flex;
		gap: 2rem;
		justify-content: center;
		flex-wrap: wrap;
		padding-left: 0;
	}
`;
